<p-toast></p-toast>

<ng-container *ngIf="!loading">
  <ng-container *ngIf="isLoggedIn && !isUserManualPage">
    <app-topbar></app-topbar>
  </ng-container>

  <div [class.padding-from-topbar]="isLoggedIn && !isUserManualPage" class="h-full">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div class="w-screen h-screen flex justify-content-center align-items-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-container>

<app-fullscreen-loader></app-fullscreen-loader>